import DocumentSimplifiedDTO from 'features/invoices/dtos/DocumentSimplifiedDTO';
import ModalFooter from 'features/shared/components/modal/ModalFooter';
import ModalHeader from 'features/shared/components/modal/ModalHeader';
import React from 'react';
import { Modal } from 'react-bootstrap';
import FileInput from 'features/shared/forms/components/FileInput';
import { useForm } from 'features/shared/forms/hooks/useForm';
import FormGroup from 'features/shared/forms/components/FormGroup';
import PromiseLoadingSpinner from 'features/shared/components/loaders/PromiseLoadingSpinner';
import { RequirementDetail_InsertRequirementDocumentDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import { insertDocumentValidations } from './insertDocumentValidations';
import DocumentTypeEnumDTO from 'features/shared/enums/dynamic/DocumentTypeEnumDTO';
import RolesChecker from 'features/customer/components/RolesChecker';
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (document: DocumentSimplifiedDTO, files: FileList) => Promise<void>;
  documentTypes: DocumentTypeEnumDTO[];
}

const InsertRequirementDocumentDialog = ({ show, setShow, onSubmit, documentTypes }: Props) => {
// translations
  const t = useTranslation("shared\\validations").t; 
  const tLabels = useTranslation("requirements\\requirements").t;

  // form hook
  const { values, errors, bindField, bindUncontrolledField, valideteForm, clearForm } = useForm({ initialValidations: insertDocumentValidations(t) });

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let document: DocumentSimplifiedDTO = {
        documentType: values["documentType"],
        name: (values["file"][0] as File).name
      };

      onSubmit(document, values["file"]);    
      clearForm();  
    }
  };

  const closeDialogHandler = () => {
    clearForm();
    setShow(false);
  }

  // render
  return (
    <RolesChecker enabledRoles="Contributor">
      <Modal show={show} onHide={closeDialogHandler} backdrop="static">
        <ModalHeader title={tLabels("insertRequirementDocumentDialog.insertDocument")} onCloseClick={closeDialogHandler} />
        <form onSubmit={submitFormHandler}>
          <div className="modal-body py-4">
            <FormGroup labelText={tLabels("insertRequirementDocumentDialog.document")} inputId="file" validationError={errors["file"]}>
              <FileInput id="file" {...bindUncontrolledField("file")} defaultText={tLabels("insertRequirementDocumentDialog.setDocument")} />
            </FormGroup>

            <FormGroup labelText="Typ dokumentu" inputId="documentType" validationError={errors["documentType"]}>
              <select className="custom-select" {...bindField('documentType')}>
                <option value="">{tLabels("insertRequirementDocumentDialog.setDocumentType")}</option>
                {documentTypes.map((documentType) => (
                  <option value={documentType.documentTypeCode}>
                    {documentType.documentTypeName}
                  </option>
                ))}
              </select>
            </FormGroup>
          </div>
          <ModalFooter>
            <button type="submit" className="btn btn-primary">{tLabels("insertRequirementDocumentDialog.send")}</button>
          </ModalFooter>
        </form>
        <PromiseLoadingSpinner area={RequirementDetail_InsertRequirementDocumentDialog} />
      </Modal>
    </RolesChecker>
  )
}

export default InsertRequirementDocumentDialog;
